import App from './App';
new App().start();
const trackCacheStatus = (name, timing) => {
  const fetchStart = timing.fetchStart;
  const responseEnd = timing.responseEnd;

  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  window.newrelic.setCustomAttribute(`warm-${name}`, responseEnd - fetchStart < 100);
};
const trackDLB = () => {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  window.newrelic.setCustomAttribute('using-dlb', true);
  window.performance.getEntries().forEach(t => {
    if (t.initiatorType === 'script' && /reporting-dlb/.test(t.name)) {
      trackCacheStatus('dlb', t);
    } else if (/knowledge-content-ui\/static-[\d.]+\/project.js/.test(t.name)) {
      trackCacheStatus('project', t);
    }
  });
};
if (window.hubspot._newRelicCallbacks) {
  window.hubspot._newRelicCallbacks.push(trackDLB);
} else {
  window.hubspot._newRelicCallbacks = [trackDLB];
}